<template>

  <!--
  Professional:
  Opportunities:
  Jobs
  Learning
  Messaging
  Networks
  Notifications

  Spiritual:
  Live Broadcast
  Prayer Corner
  Soul Winning
  Testimonies


  Profile Views
  Products
  Finance

  -->
  <SideBarAsideMail/>

  <div class="mail-wrapper">
    <div class="mail-sidebar">
      <div class="mail-sidebar-body">
        <div class="d-grid pd-20">
          <button id="mailComposeBtn"
                  class="btn btn-primary btn-block tx-uppercase tx-10 tx-medium tx-sans tx-spacing-4">Send Message
          </button>
        </div>
        <div class="pd-b-10 pd-x-10">
          <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10 mg-b-10">Spiritual</label>
          <nav class="nav nav-sidebar tx-13">
            <a href="" class="nav-link active"><i data-feather="inbox"></i> <span>Networks</span> <span
                class="badge">20</span></a>
            <a href="" class="nav-link"><i data-feather="monitor"></i> <span>Service Groups</span> <span
                class="badge">3</span></a>
            <a href="" class="nav-link"><i data-feather="clock"></i> <span>Watch</span> <span
                class="badge">10</span></a>
            <a href="" class="nav-link"><i data-feather="star"></i> <span>Prayer</span> <span class="badge">8</span></a>
            <a href="" class="nav-link"><i data-feather="file"></i> <span>Books</span> <span class="badge">15</span></a>
            <a href="" class="nav-link"><i data-feather="slash"></i> <span>Events</span> <span class="badge">128</span></a>
            <a href="" class="nav-link"><i data-feather="star"></i> <span>Kingdom Care</span> <span
                class="badge">8</span></a>
            <a href="" class="nav-link"><i data-feather="trash"></i> <span>Trash</span> <span class="badge">6</span></a>
          </nav>
        </div>

        <div class="pd-10">
          <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10">Professional</label>
          <nav class="nav nav-sidebar tx-13">
            <a href="" class="nav-link"><i data-feather="briefcase"></i> <span>Jobs</span></a>
            <a href="" class="nav-link"><i data-feather="book-open"></i> <span>Learning</span></a>
            <a href="" class="nav-link"><i data-feather="message-square"></i> <span>Messaging</span></a>
            <a href="" class="nav-link"><i data-feather="share-2"></i> <span>Networks</span></a>
            <a href="" class="nav-link"><i data-feather="gift"></i> <span>Opportunities</span></a>
            <a href="" class="nav-link"><i data-feather="bell"></i> <span>Notifications</span></a>
          </nav>
        </div>

        <div class="pd-10">
          <label class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 pd-l-10">Body</label>
          <nav class="nav nav-sidebar tx-13">
            <a href="" class="nav-link"><i data-feather="menu"></i> <span>Nutrition</span></a>
            <a href="" class="nav-link"><i data-feather="activity"></i> <span>Self Mgt</span></a>
            <a href="" class="nav-link"><i data-feather="sun"></i> <span>Exercise</span></a>
          </nav>
        </div>
      </div><!-- mail-sidebar-body -->
    </div><!-- mail-sidebar -->

    <div class="mail-group">
      <div class="mail-group-header">
        <i data-feather="search"></i>
        <div class="search-form">
          <input type="search" class="form-control" placeholder="Search ...">
        </div>
      </div>
      <div class="mail-group-body">

        <ul class="list-unstyled media-list d-block d-md-none">
          <li class="media bg-primary">
            <div class="media-body mg-l-15">
              <div class="tx-color-03 d-flex align-items-center justify-content-between mg-b-2">
                <em class="tx-12 text-white"> {{ state.first_name }} {{ state.last_name }}</em>
              </div>
              <h6 class="tx-13 text-white">Click here for full Details</h6>
            </div><!-- media-body -->
          </li>
        </ul>

        <div class="card-body pd-10 pd-sm-20">
          <div class="clearfix mg-b-25">
            <div id="contactAvatar" class="pos-relative float-start">
              <div class="avatar avatar-xl">
                <img v-if="state.profile_picture" :src="`${profileFolder}/${state.profile_picture}`" class="rounded-circle" alt="">
                <span v-else class="avatar-initial rounded-circle bg-gray-600">{{ state.first_name?.charAt(0) }}</span>
              </div>
              <a href="" class="contact-edit-photo" data-bs-toggle="tooltip" title="Upload Photo"><i
                  data-feather="edit-2"></i></a>
            </div>
          </div>
          <h5 id="contactName" class="tx-18 tx-xl-20 mg-b-5"> {{ state.first_name }} {{ state.last_name }} </h5>


                    <p class="tx-13 tx-lg-12 tx-xl-13 tx-color-03 mg-b-20">Description and role if any.</p>
                    <hr class="mg-y-5">

          <div class="profile-sidebar profile-sidebar-two pd-lg-r-15" data-v-5357d476="" style="margin-top: -30px;">
            <div class="row" data-v-5357d476="">

              <div class="col-sm-8 col-md-7 col-lg-12 mg-t-10 mg-sm-t-0 mg-lg-t-25" data-v-5357d476="">

                <div class="d-flex" data-v-5357d476="">
                  <div class="profile-skillset flex-fill" data-v-5357d476=""><h4 data-v-5357d476=""><a href=""
                                                                                                       class="link-01"
                                                                                                       data-v-5357d476="">1.4k</a>
                  </h4><label data-v-5357d476="">Stars</label></div>
                  <div class="profile-skillset flex-fill" data-v-5357d476=""><h4 data-v-5357d476=""><a href=""
                                                                                                       class="link-01"
                                                                                                       data-v-5357d476="">2.8k</a>
                  </h4><label data-v-5357d476="">Followers</label></div>
                  <div class="profile-skillset flex-fill" data-v-5357d476=""><h4 data-v-5357d476=""><a href=""
                                                                                                       class="link-01"
                                                                                                       data-v-5357d476="">437</a>
                  </h4><label data-v-5357d476="">Following</label></div>
                </div>
              </div>

              <div class="col-sm-6 col-md-5 col-lg-12 mg-t-20" data-v-5357d476=""><label
                  class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15" data-v-5357d476="">Tags / Groups</label>
                <ul class="list-inline list-inline-skills" data-v-5357d476="">
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">HTML5</a></li>
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">Sass</a></li>
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">CSS</a></li>
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">React</a></li>
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">jQuery</a></li>
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">Angular</a></li>
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">Wordpress</a></li>
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">Photoshop</a></li>
                  <li class="list-inline-item" data-v-5357d476=""><a href="" data-v-5357d476="">PHP</a></li>
                </ul>
              </div><!-- col -->


              <div class="col-sm-6 col-md-5 col-lg-12 mg-t-5" data-v-5357d476=""><label
                  class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15" data-v-5357d476="">Websites
                &amp; Social Channel</label>
                <ul class="list-unstyled profile-info-list" data-v-5357d476="">
                  <li data-v-5357d476="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-globe" data-v-5357d476="">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="2" y1="12" x2="22" y2="12"></line>
                      <path
                          d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                    <a href="" data-v-5357d476="">http://fenchiumao.me/</a></li>
                  <li data-v-5357d476="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-github" data-v-5357d476="">
                      <path
                          d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                    </svg>
                    <a href="" data-v-5357d476="">@fenchiumao</a></li>
                  <li data-v-5357d476="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-twitter" data-v-5357d476="">
                      <path
                          d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                    </svg>
                    <a href="" data-v-5357d476="">@fenmao</a></li>
                </ul>
              </div><!-- col -->



              <div class="col-sm-6 col-md-5 col-lg-12 mg-t-5" data-v-5357d476=""><label
                  class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15" data-v-5357d476="">Contact
                Information</label>
                <ul class="list-unstyled profile-info-list" data-v-5357d476="">

                  <li data-v-5357d476="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-briefcase" data-v-5357d476="">
                      <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    </svg>
                    <span class="tx-color-03" data-v-5357d476="">{{ state.town_city }} </span></li>

                  <li data-v-5357d476="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-home" data-v-5357d476="">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    <span class="tx-color-03" data-v-5357d476=""> {{ state.county }} </span></li>


                  <li data-v-5357d476="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-home" data-v-5357d476="">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    <span class="tx-color-03" data-v-5357d476=""> {{ state.contact_address }}  </span></li>

                  <li data-v-5357d476="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-home" data-v-5357d476="">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                      <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    <span class="tx-color-03" data-v-5357d476=""> {{ state.post_code }} </span></li>



                  <li data-v-5357d476="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                         class="feather feather-phone" data-v-5357d476="">
                      <path
                          d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    <a href="" data-v-5357d476=""> {{state.phone_number}}</a></li>

                </ul>
              </div><!-- col -->

<!--              <div class="col-sm-6 col-md-5 col-lg-12 mg-t-40" data-v-5357d476="">-->
<!--                <label class="tx-sans tx-10 tx-semibold tx-uppercase tx-color-01 tx-spacing-1 mg-b-15" data-v-5357d476="">Explore</label>-->
<!--              </div>-->
             </div>
          </div>

        </div>

      </div><!-- mail-group-body -->
    </div><!-- mail-group -->


    <div class="mail-content">

      <div class="mail-content-header">
        <a href="" id="mailContentClose" class="link-02 d-none d-lg-block d-xl-none mg-r-20"><i
            data-feather="arrow-left"></i></a>
        <div class="media">
          <div class="avatar avatar-sm">
            <img v-if="state.profile_picture" :src="`${profileFolder}/${state.profile_picture}`" class="rounded-circle" alt="">
            <span v-else class="avatar-initial rounded-circle bg-gray-600">{{ state.first_name?.charAt(0) }}</span>
          </div>
          <div class="media-body mg-l-10">
            <h6 class="mg-b-2 tx-13"> {{ state.first_name }} {{ state.middle_name }} {{ state.last_name }} </h6>
            <span class="d-block tx-11 tx-color-03">Last Seen: Today, 11:40am</span>
          </div><!-- media-body -->
        </div><!-- media -->
        <nav class="nav nav-icon-only mg-l-auto">
          <a href="" data-bs-toggle="tooltip" title="Mark Important" class="nav-link d-none d-sm-block"><i
              data-feather="star"></i></a>

          <span class="nav-divider d-none d-sm-block"></span>
          <a href="" data-bs-toggle="tooltip" title="Archive" class="nav-link d-none d-sm-block"><i
              data-feather="archive"></i></a>
          <a href="" data-bs-toggle="tooltip" title="Trash" class="nav-link d-none d-sm-block"><i
              data-feather="trash"></i></a>
          <a href="" data-bs-toggle="tooltip" title="Print" class="nav-link d-none d-sm-block"><i
              data-feather="printer"></i></a>
          <a href="" data-bs-toggle="tooltip" title="Options" class="nav-link d-sm-none"><i
              data-feather="more-vertical"></i></a>
        </nav>
      </div><!-- mail-content-header -->


      <div class="mail-content-body" >
        <div class="pd-20 pd-lg-25 pd-xl-30"> <!-- style="background: #F4F5F9" -->
          <div class="contact-content-header">
            <nav class="nav">
              <a href="#contactInformation" class="nav-link active" data-bs-toggle="tab">Contact Info</a>
<!--              <a href="#contactLogs" class="nav-link" data-bs-toggle="tab"> Call Logs </a>-->
<!--              <a href="#contactLogs" class="nav-link" data-bs-toggle="tab"> Family </a>-->
<!--              <a href="#contactLogs" class="nav-link" data-bs-toggle="tab"> Skills </a>-->
<!--              <a href="#contactLogs" class="nav-link" data-bs-toggle="tab"><span>Call </span>Logs</a>-->
            </nav>
            <a href="" id="contactOptions" class="text-secondary mg-l-auto d-xl-none"><i
                data-feather="more-horizontal"></i></a>
          </div><!-- contact-content-header -->


          <div class="mg-t-30">
            <div class="tab-content">


              <div id="contactInformation" class="tab-pane show active pd-20 pd-xl-25">

                <div class="d-flex align-items-center justify-content-between mg-b-25">
                  <h6 class="mg-b-0">Personal Details</h6>
                  <div class="d-flex">
                    <a href="#modalEditContact" data-bs-toggle="modal"
                       class="btn btn-sm btn-white d-flex align-items-center mg-r-5"><i data-feather="edit-2"></i><span
                        class="d-none d-sm-inline mg-l-5"> Edit</span></a>
                    <a href="#modalDeleteContact" data-bs-toggle="modal"
                       class="btn btn-sm btn-white d-flex align-items-center"><i data-feather="trash"></i><span
                        class="d-none d-sm-inline mg-l-5"> Delete</span></a>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 col-sm">
                    <label
                        class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Firstname</label>
                    <p class="mg-b-0">{{ state.first_name }}</p>
                  </div><!-- col -->
                  <div class="col-6 col-sm">
                    <label
                        class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Middlename</label>
                    <p class="mg-b-0">{{ state.middle_name }} </p>
                  </div><!-- col -->
                  <div class="col-sm mg-t-20 mg-sm-t-0">
                    <label
                        class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Lastname</label>
                    <p class="mg-b-0">{{ state.last_name }}</p>
                  </div><!-- col -->
                </div><!-- row -->

                <h6 class="mg-t-40 mg-b-20">Contact Details</h6>

                <div class="row row-sm">
                  <div class="col-6 col-sm-4">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Mobile
                      Phone</label>
                    <p class="tx-primary tx-rubik mg-b-0"> {{ state.phone_number }}</p>
                  </div>
                  <div class="col-6 col-sm-4">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Home
                      Phone</label>
                    <p class="tx-primary tx-rubik mg-b-0"> {{ state.phone_number }} </p>
                  </div>
                  <div class="col-6 col-sm-4 mg-t-20 mg-sm-t-0">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Work
                      Phone</label>
                    <p class="tx-primary tx-rubik mg-b-0">{{ state.phone_number }}</p>
                  </div>
                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Email
                      Address</label>
                    <p class="tx-primary mg-b-0">{{ state.email }}</p>
                  </div>
                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Marital
                      Status</label>
                    <p class="mg-b-0">{{ state.marital_status }}</p>
                  </div>
                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Birthday
                      Month</label>
                    <p class="mg-b-0">{{ state.birthday_day }} / {{ state.birthday_month }}</p>
                  </div>
                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Gender</label>
                    <p class="mg-b-0">{{ state.gender }}</p>
                  </div>
                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">BFC / WOFBI
                      Status</label>
                    <p class="mg-b-0">{{ state.bfc_status }} | {{ state.wofbi_status }}</p>
                  </div>
                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Water
                      Baptism</label>
                    <p class="mg-b-0">{{ state.water_baptism }}</p>
                  </div>
                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">First
                      Attendance</label>
                    <p class="tx-primary mg-b-0">{{ state.first_attendance }}</p>
                  </div>

                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Service
                      Unit</label>
                    <p class="mg-b-0">{{ state.service_unit }}</p>
                  </div>
                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Social
                      Profiles</label>
                    <nav class="nav nav-social">
                      <a href="" class="nav-link"><i data-feather="facebook"></i></a>
                      <a href="" class="nav-link"><i data-feather="twitter"></i></a>
                      <a href="" class="nav-link"><i data-feather="instagram"></i></a>
                      <a href="" class="nav-link"><i data-feather="github"></i></a>
                    </nav>
                  </div><!-- col -->
                  <div class="col-sm mg-t-20 mg-sm-t-30">
                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Contact
                      Address</label>
                    <p class="tx-13 mg-b-0"> {{ state.contact_address }} {{ state.town_city }} {{ state.county }}
                      {{ state.post_code }} </p>
                  </div>
                </div><!-- row -->
              </div>


<!--              <div id="contactLogs" class="tab-pane pd-20 pd-xl-25">-->
<!--                <div class="d-flex align-items-center justify-content-between mg-b-30">-->
<!--                  <div class="media-body mg-t-40 mg-lg-t-0 pd-lg-x-10">-->
<!--                    <div class="profile-update-option bg-white ht-50 bd d-flex justify-content-end mg-b-20 mg-lg-b-25 rounded">-->
<!--                      <div class="d-flex align-items-center pd-x-20 mg-r-auto">-->
<!--                        <i data-feather="edit-3"></i> <a href="" class="link-03 mg-l-10"><span class="d-none d-sm-inline">Share an</span> Update</a>-->
<!--                      </div>-->
<!--                      <div class="wd-50 bd-l d-flex align-items-center justify-content-center">-->
<!--                        <a href="" class="link-03" data-bs-toggle="tooltip" title="Publish Photo"><i data-feather="image"></i></a>-->
<!--                      </div>-->
<!--                      <div class="wd-50 bd-l d-flex align-items-center justify-content-center">-->
<!--                        <a href="" class="link-03" data-bs-toggle="tooltip" title="Publish Video"><i data-feather="video"></i></a>-->
<!--                      </div>-->
<!--                      <div class="wd-50 bd-l d-flex align-items-center justify-content-center">-->
<!--                        <a href="" class="link-03" data-bs-toggle="tooltip" title="Write an Article"><i data-feather="file-text"></i></a>-->
<!--                      </div>-->
<!--                    </div>-->

<!--                    <div class="card mg-b-20 mg-lg-b-25">-->
<!--                      <div class="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-between">-->
<!--                        <h6 class="tx-uppercase tx-semibold mg-b-0">Latest Activity</h6>-->
<!--                        <nav class="nav nav-icon-only">-->
<!--                          <a href="" class="nav-link"><i data-feather="more-horizontal"></i></a>-->
<!--                        </nav>-->
<!--                      </div>&lt;!&ndash; card-header &ndash;&gt;-->
<!--                      <div class="card-body pd-20 pd-lg-25">-->
<!--                        <div class="media align-items-center mg-b-20">-->
<!--                          <div class="avatar avatar-online"><img src="https://placehold.co/500" class="rounded-circle" alt=""></div>-->
<!--                          <div class="media-body pd-l-15">-->
<!--                            <h6 class="mg-b-3">Dyanne Aceron</h6>-->
<!--                            <span class="d-block tx-13 tx-color-03">Cigarette Butt Collector</span>-->
<!--                          </div>-->
<!--                          <span class="d-none d-sm-block tx-12 tx-color-03 align-self-start">5 hours ago</span>-->
<!--                        </div>&lt;!&ndash; media &ndash;&gt;-->
<!--                        <p class="mg-b-20">Our team is expanding again. We are looking for a Product Manager and Software Engineer to drive our new aspects of our capital projects. If you're interested, please drop a comment here or simply message me. <a href="">#softwareengineer</a> <a href="">#engineering</a></p>-->

<!--                        <div class="bd bg-gray-50 pd-y-15 pd-x-15 pd-sm-x-20">-->
<!--                          <h6 class="tx-15 mg-b-3">We're hiring of Product Manager</h6>-->
<!--                          <p class="mg-b-0 tx-14">Full-time, $60,000 - $80,000 annual</p>-->
<!--                          <span class="tx-13 tx-color-03">Bay Area, San Francisco, CA</span>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="card-footer bg-transparent pd-y-10 pd-sm-y-15 pd-x-10 pd-sm-x-20">-->
<!--                        <nav class="nav nav-with-icon tx-13">-->
<!--                          <a href="" class="nav-link"><i data-feather="thumbs-up"></i> Like</a>-->
<!--                          <a href="" class="nav-link"><i data-feather="message-square"></i> Comment</a>-->
<!--                          <a href="" class="nav-link"><i data-feather="share"></i> Share</a>-->
<!--                        </nav>-->
<!--                      </div>&lt;!&ndash; card-footer &ndash;&gt;-->
<!--                    </div>&lt;!&ndash; card &ndash;&gt;-->

<!--                    <div class="card mg-b-20 mg-lg-b-25">-->
<!--                      <div class="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-between">-->
<!--                        <h6 class="tx-uppercase tx-semibold mg-b-0">Work Experience</h6>-->
<!--                        <nav class="nav nav-with-icon tx-13">-->
<!--                          <a href="" class="nav-link"><i data-feather="plus"></i> Add New</a>-->
<!--                        </nav>-->
<!--                      </div>&lt;!&ndash; card-header &ndash;&gt;-->
<!--                      <div class="card-body pd-25">-->
<!--                        <div class="media d-block d-sm-flex">-->
<!--                          <div class="wd-80 ht-80 bg-ui-04 rounded d-flex align-items-center justify-content-center">-->
<!--                            <i data-feather="briefcase" class="tx-white-7 wd-40 ht-40"></i>-->
<!--                          </div>-->
<!--                          <div class="media-body pd-t-25 pd-sm-t-0 pd-sm-l-25">-->
<!--                            <h5 class="mg-b-5">Area Sales Manager</h5>-->
<!--                            <p class="mg-b-3 tx-color-02"><span class="tx-medium tx-color-01">ThemePixels, Inc.</span>, Bay Area, San Francisco, CA</p>-->
<!--                            <span class="d-block tx-13 tx-color-03">December 2016 - Present</span>-->

<!--                            <ul class="pd-l-10 mg-0 mg-t-20 tx-13">-->
<!--                              <li>Reaching the targets and goals set for my area.</li>-->
<!--                              <li>Servicing the needs of my existing customers.</li>-->
<!--                              <li>Maintaining the relationships with existing customers for repeat business.</li>-->
<!--                              <li>Reporting to top managers.</li>-->
<!--                              <li>Keeping up to date with the products.</li>-->
<!--                            </ul>-->
<!--                          </div>-->
<!--                        </div>&lt;!&ndash; media &ndash;&gt;-->
<!--                      </div>-->
<!--                      <div class="card-footer bg-transparent pd-y-15 pd-x-20">-->
<!--                        <nav class="nav nav-with-icon tx-13">-->
<!--                          <a href="" class="nav-link">-->
<!--                            Show More Experiences (4)-->
<!--                            <i data-feather="chevron-down" class="mg-l-2 mg-r-0 mg-t-2"></i>-->
<!--                          </a>-->
<!--                        </nav>-->
<!--                      </div>&lt;!&ndash; card-footer &ndash;&gt;-->
<!--                    </div>&lt;!&ndash; card &ndash;&gt;-->

<!--                    <div class="card mg-b-20 mg-lg-b-25">-->
<!--                      <div class="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-between">-->
<!--                        <h6 class="tx-uppercase tx-semibold mg-b-0">Education</h6>-->
<!--                        <nav class="nav nav-with-icon tx-13">-->
<!--                          <a href="" class="nav-link"><i data-feather="plus"></i> Add New</a>-->
<!--                        </nav>-->
<!--                      </div>&lt;!&ndash; card-header &ndash;&gt;-->
<!--                      <div class="card-body pd-25">-->
<!--                        <div class="media">-->
<!--                          <div class="wd-80 ht-80 bg-ui-04 rounded d-flex align-items-center justify-content-center">-->
<!--                            <i data-feather="book-open" class="tx-white-7 wd-40 ht-40"></i>-->
<!--                          </div>-->
<!--                          <div class="media-body pd-l-25">-->
<!--                            <h5 class="mg-b-5">BS in Computer Science</h5>-->
<!--                            <p class="mg-b-3"><span class="tx-medium tx-color-02">Holy Name University</span>,  Tagbilaran City, Bohol</p>-->
<!--                            <span class="d-block tx-13 tx-color-03">2002-2006</span>-->
<!--                          </div>-->
<!--                        </div>&lt;!&ndash; media &ndash;&gt;-->
<!--                      </div>-->
<!--                      <div class="card-footer bg-transparent pd-y-15 pd-x-20">-->
<!--                        <nav class="nav nav-with-icon tx-13">-->
<!--                          <a href="" class="nav-link">-->
<!--                            Show More Education (2)-->
<!--                            <i data-feather="chevron-down" class="mg-l-2 mg-r-0 mg-t-2"></i>-->
<!--                          </a>-->
<!--                        </nav>-->
<!--                      </div>&lt;!&ndash; card-footer &ndash;&gt;-->
<!--                    </div>&lt;!&ndash; card &ndash;&gt;-->

<!--                    <div class="card card-profile-interest">-->
<!--                      <div class="card-header pd-y-15 pd-x-20 d-flex align-items-center justify-content-between">-->
<!--                        <h6 class="tx-uppercase tx-semibold mg-b-0">Interests</h6>-->
<!--                        <nav class="nav nav-with-icon tx-13">-->
<!--                          <a href="" class="nav-link">Browse Interests <i data-feather="arrow-right" class="mg-l-5 mg-r-0"></i></a>-->
<!--                        </nav>-->
<!--                      </div>&lt;!&ndash; card-header &ndash;&gt;-->
<!--                      <div class="card-body pd-25">-->
<!--                        <div class="row">-->
<!--                          <div class="col-sm col-lg-12 col-xl">-->
<!--                            <div class="media">-->
<!--                              <div class="wd-45 ht-45 bg-gray-900 rounded d-flex align-items-center justify-content-center">-->
<!--                                <i data-feather="github" class="tx-white-7 wd-20 ht-20"></i>-->
<!--                              </div>-->
<!--                              <div class="media-body pd-l-25">-->
<!--                                <h6 class="tx-color-01 mg-b-5">Github, Inc.</h6>-->
<!--                                <p class="tx-12 mg-b-10">Web-based hosting service for version control using Git... <a href="">Learn more</a></p>-->
<!--                                <span class="tx-12 tx-color-03">6,182,220 Followers</span>-->
<!--                              </div>-->
<!--                            </div>&lt;!&ndash; media &ndash;&gt;-->

<!--                            <div class="media">-->
<!--                              <div class="wd-45 ht-45 bg-warning rounded d-flex align-items-center justify-content-center">-->
<!--                                <i data-feather="truck" class="tx-white-7 wd-20 ht-20"></i>-->
<!--                              </div>-->
<!--                              <div class="media-body pd-l-25">-->
<!--                                <h6 class="tx-color-01 mg-b-5">DHL Express</h6>-->
<!--                                <p class="tx-12 mg-b-10">Logistics company providing international courier service... <a href="">Learn more</a></p>-->
<!--                                <span class="tx-12 tx-color-03">3,005,192 Followers</span>-->
<!--                              </div>-->
<!--                            </div>&lt;!&ndash; media &ndash;&gt;-->
<!--                          </div>&lt;!&ndash; col &ndash;&gt;-->
<!--                          <div class="col-sm col-lg-12 col-xl mg-t-25 mg-sm-t-0 mg-lg-t-25 mg-xl-t-0">-->
<!--                            <div class="media">-->
<!--                              <div class="wd-45 ht-45 bg-primary rounded d-flex align-items-center justify-content-center">-->
<!--                                <i data-feather="facebook" class="tx-white-7 wd-20 ht-20"></i>-->
<!--                              </div>-->
<!--                              <div class="media-body pd-l-25">-->
<!--                                <h6 class="tx-color-01 mg-b-5">Facebook, Inc.</h6>-->
<!--                                <p class="tx-12 mg-b-10">Online social media and social networking service company... <a href="">Learn more</a></p>-->
<!--                                <span class="tx-12 tx-color-03">12,182,220 Followers</span>-->
<!--                              </div>-->
<!--                            </div>&lt;!&ndash; media &ndash;&gt;-->

<!--                            <div class="media">-->
<!--                              <div class="wd-45 ht-45 bg-pink rounded d-flex align-items-center justify-content-center">-->
<!--                                <i data-feather="instagram" class="tx-white-7 wd-20 ht-20"></i>-->
<!--                              </div>-->
<!--                              <div class="media-body pd-l-25">-->
<!--                                <h6 class="tx-color-01 mg-b-5">Instagram</h6>-->
<!--                                <p class="tx-12 mg-b-10">Photo and video-sharing social networking service by Facebook... <a href="">Learn more</a></p>-->
<!--                                <span class="tx-12 tx-color-03">3,005,192 Followers</span>-->
<!--                              </div>-->
<!--                            </div>&lt;!&ndash; media &ndash;&gt;-->
<!--                          </div>&lt;!&ndash; col &ndash;&gt;-->
<!--                        </div>&lt;!&ndash; row &ndash;&gt;-->
<!--                      </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--                    </div>&lt;!&ndash; card &ndash;&gt;-->

<!--                  </div>&lt;!&ndash; media-body &ndash;&gt;-->
<!--                </div>-->
<!--              </div>&lt;!&ndash; tab-pane &ndash;&gt;-->



            </div><!-- tab-content -->

          </div><!-- card-body -->
        </div>

      </div><!-- mail-content-body -->

    </div><!-- mail-content -->
  </div><!-- mail-wrapper -->


  <div id="mailCompose" class="mail-compose">
    <div class="mail-compose-dialog">
      <div class="mail-compose-header">
        <h6 class="mail-compose-title tx-white">New Message</h6>
        <nav class="nav nav-icon-only">
          <a id="mailComposeMinimize" href="" class="nav-link nav-link-minimize d-none d-lg-block">
            <i data-feather="minus"></i>
            <i data-feather="square"></i>
          </a>
          <a id="mailComposeShrink" href="" class="nav-link nav-link-shrink d-none d-lg-block">
            <i data-feather="minimize-2"></i>
            <i data-feather="maximize-2"></i>
          </a>
          <a id="mailComposeClose" href="" class="nav-link nav-link-close"><i data-feather="x"></i></a>
        </nav>
      </div><!-- mail-compose-header -->
      <div class="mail-compose-body">
        <div class="row align-items-center flex-nowrap">
          <div class="col-sm-2">Recipient:</div>
          <div class="col-sm-10">
            <input type="text" class="form-control bd-0 pd-x-0" placeholder="Enter recipient's email address">
          </div>
        </div>
        <hr class="mg-y-10">
        <div class="row align-items-center flex-nowrap">
          <div class="col-sm-2">Subject:</div>
          <div class="col-sm-10">
            <input type="text" class="form-control bd-0 pd-x-0" placeholder="Enter subject">
          </div>
        </div>
        <div id="editor-container2" class="ht-150 mg-t-15"></div>
        <div class="d-sm-flex align-items-center justify-content-between mg-t-25">
          <div id="toolbar-container2" class="bd-0-f pd-0-f">
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
              </span>
            <span class="ql-formats">
                <button class="ql-link"></button>
                <button class="ql-image"></button>
              </span>
          </div>
          <div class="tx-13 mg-t-15 mg-sm-t-0">
            <button class="btn btn-white mg-r-5">Save as Draft</button>
            <button class="btn btn-primary">Send</button>
          </div>
        </div>
      </div><!-- mail-compose-body -->
    </div><!-- mail-compose-dialog -->
  </div><!-- mail-compose -->





  <div class="modal fade effect-scale" id="modalEditContact" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-body pd-20 pd-sm-30">
          <a href="" type="button" class="close pos-absolute t-20 r-20 text-secondary" data-bs-dismiss="modal"
             aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </a>

          <h5 class="tx-18 tx-sm-20 mg-b-20">Edit Contact</h5>
          <p class="tx-13 tx-color-03 mg-b-30">You can add more information than what you see here, such as address and
            birthday by clicking <span class="tx-color-02">Add More Fields</span> button below to bring up more options.
          </p>

          <div class="d-sm-flex">
            <div class="mg-sm-r-30">
              <div class="pos-relative d-inline-block mg-b-20">
                <div class="avatar avatar-xxl">
                  <img v-if="state.profile_picture" :src="`${profileFolder}/${state.profile_picture}`" class="rounded-circle" alt="">
                  <span v-else class="avatar-initial rounded-circle bg-gray-700 tx-normal">{{ state.first_name?.charAt(0) }}</span>
                </div>
                <a href="" @click.prevent="$refs.photoInput.click()" class="contact-edit-photo"><i data-feather="edit-2"></i></a>
                <input type="file" ref="photoInput" style="display: none" accept=".jpg,.jpeg,.png" @change="onPhotoSelected">
              </div>
            </div><!-- col -->
            <div class="flex-fill">


              <fieldset class="form-fieldset">
                <legend>Personal Information</legend>

                <div class="">
                  <div class="row mg-b-10">
                    <div class="col-sm">
                      <div class="form-group-mat" :class="{'has-value': state.first_name }">
                        <label class="d-block">Firstname</label>
                        <input v-model="state.first_name" type="text">
                        <div v-if="v$.first_name.$error" class="tx-danger">{{ v$.first_name.$errors[0].$message }}</div>
                      </div>
                    </div>

                    <div class="col-sm">
                      <div class="form-group-mat" :class="{'has-value': state.middle_name }">
                        <label class="d-block">Middle Name</label>
                        <input v-model="state.middle_name" type="text">
                      </div>
                    </div>

                    <div class="col-sm">
                      <div class="form-group-mat" :class="{'has-value': state.last_name }">
                        <label class="d-block">Lastname</label>
                        <input v-model="state.last_name" type="text" placeholder="Enter lastname">
                        <div v-if="v$.last_name.$error" class="tx-danger">{{
                            v$.last_name.$errors[0].$message
                          }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mg-b-10">

                  </div>

                  <div class="row mg-b-10">

                    <div class="col-sm">
                      <div class="form-group-mat" :class="{'has-value': state.email }">
                        <label class="d-block">Email</label>
                        <input v-model="state.email" type="text" placeholder="Enter email">
                        <div v-if="v$.email.$error" class="tx-danger">{{
                            v$.email.$errors[0].$message
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="col-sm">
                      <div class="form-group-mat" :class="{'has-value': state.phone_number }">
                        <label class="d-block">Phone Number</label>
                        <input v-model="state.phone_number" type="text">
                        <div v-if="v$.phone_number.$error" class="tx-danger">{{
                            v$.phone_number.$errors[0].$message
                          }}
                        </div>
                      </div>
                    </div>

                    <div class="col-sm">
                      <div class="form-group-mat select-has-value">
                        <label class="d-block">Marital Status</label>
                        <select v-model="state.marital_status">
                          <option label="Choose Marital Status"></option>
                          <option value="married">Married</option>
                          <option value="single">Single</option>
                          <option value="separated">Separated</option>
                          <option value="divorced">Divorced</option>
                          <option value="widowed">Widowed</option>
                        </select>
                      </div>
                    </div>
                  </div>


                  <div class="row mg-b-10">
                    <div class="col-sm">
                      <div class="form-group-mat select-has-value">
                        <label class="d-block">Birthday Month</label>
                        <select v-model="state.birthday_month">
                          <option label="Choose Month of Birth"></option>
                          <option value="1">January</option>
                          <option value="2">February</option>
                          <option value="3">March</option>
                          <option value="4">April</option>
                          <option value="5">May</option>
                          <option value="6">June</option>
                          <option value="7">July</option>
                          <option value="8">August</option>
                          <option value="9">September</option>
                          <option value="10">October</option>
                          <option value="11">November</option>
                          <option value="12">December</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm">
                      <div class="form-group-mat select-has-value">
                        <label class="d-block"> Birthday Day</label>
                        <select v-model="state.birthday_day">
                          <option label="Enter Birthday Day"></option>
                          <option v-for="i in 31" :key="i">{{ i }}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-sm">
                      <div class="form-group-mat select-has-value">
                        <label class="d-block">Gender</label>
                        <select v-model="state.gender">
                          <option label="Choose Gender"></option>
                          <option value="male">MALE</option>
                          <option value="female">FEMALE</option>
                        </select>
                        <div v-if="v$.gender.$error" class="tx-danger">{{ v$.gender.$errors[0].$message }}</div>
                      </div>
                    </div>

                  </div>

                </div>
              </fieldset>


              <fieldset class="form-fieldset mg-t-30">
                <legend>Address Information</legend>

                <div class="row mg-b-10">
                  <div class="col-sm">
                    <div class="form-group-mat" :class="{'has-value': state.contact_address }">
                      <label class="d-block">Contact Address</label>
                      <input v-model="state.contact_address" type="text">
                      <div v-if="v$.contact_address.$error" class="tx-danger">{{
                          v$.contact_address.$errors[0].$message
                        }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mg-b-1">
                  <div class="col-sm">
                    <div class="form-group-mat" :class="{'has-value': state.town_city }">
                      <label class="d-block">Town / City</label>
                      <input v-model="state.town_city" type="text">
                      <div v-if="v$.town_city.$error" class="tx-danger">{{
                          v$.town_city.$errors[0].$message
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="col-sm">
                    <div class="form-group-mat" :class="{'has-value': state.county}">
                      <label class="d-block">County</label>
                      <input v-model="state.county" type="text">
                      <div v-if="v$.county.$error" class="tx-danger">{{
                          v$.county.$errors[0].$message
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="col-sm">
                    <div class="form-group-mat" :class="{'has-value': state.post_code}">
                      <label class="d-block">Post Code</label>
                      <input v-model="state.post_code" type="text">
                      <div v-if="v$.post_code.$error" class="tx-danger">{{
                          v$.post_code.$errors[0].$message
                        }}
                      </div>
                    </div>
                  </div>

                </div>

              </fieldset>


              <fieldset class="form-fieldset mg-t-30">
                <legend>Spiritual Information</legend>

                <div class="row mg-b-10">

                  <div class="col-sm mg-b-15">
                    <div class="form-group-mat" :class="{'has-value': state.first_attendance}">
                      <label class="d-block"> First Attendance</label>
                      <input v-model="state.first_attendance" type="text" onfocus="(this.type='date')"
                             onblur="(this.type='text')" placeholder="Enter first attendance day"/>
                      <label v-if="v$.first_attendance.$error" class="tx-danger">{{
                          v$.first_attendance.$errors[0].$message
                        }}</label>
                    </div>
                  </div>

                  <div class="col-sm mg-b-15">
                    <div class="form-group-mat" :class="{'has-value': state.bfc_status }">
                      <label class="d-block"> BFC Status (Has Done Foundation Class?)</label>
                      <select v-model="state.bfc_status">
                        <option label=""></option>
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                      <div v-if="v$.bfc_status.$error" class="tx-danger">{{ v$.bfc_status.$errors[0].$message }}</div>
                    </div>
                  </div>
                </div>

                <div class="row mg-b-10">
                  <div class="col-sm">
                    <div class="form-group-mat" :class="{'has-value': state.water_baptism }">
                      <label class="d-block">Water Baptism</label>
                      <select v-model="state.water_baptism">
                        <option label=""></option>
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                      <div v-if="v$.water_baptism.$error" class="tx-danger">{{
                          v$.water_baptism.$errors[0].$message
                        }}
                      </div>
                    </div>
                  </div>

                  <div class="col-sm">
                    <div class="form-group-mat select-has-value">
                      <label class="d-block"> Service Unit</label>
                      <select v-model="state.service_unit">
                        <option label=""></option>
                        <option value="Technical">Technical</option>
                        <option value="Ushering">Ushering</option>
                        <option value="Finance">Finance</option>
                        <option value="Sanctuary Keepers">Sanctuary Keepers</option>
                        <option value="Altar Minister">Altar Minister</option>
                        <option value="Children Uni">Children Unit</option>
                        <option value="yaf">Youth Alive Exco</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm">
                    <div class="form-group-mat select-has-value">
                      <label class="d-block"> WOFBI Status</label>
                      <select v-model="state.wofbi_status">
                        <option label="Has Done WOFBI?"></option>
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                      </select>
                      <div v-if="v$.wofbi_status.$error" class="tx-danger">{{
                          v$.wofbi_status.$errors[0].$message
                        }}
                      </div>
                    </div>
                  </div>
                </div>

              </fieldset>

              <label v-if="formError" class="tx-danger">{{ formError }}</label>

            </div><!-- col -->
          </div>
        </div>


        <div class="modal-footer">
          <div class="wd-100p d-flex flex-column flex-sm-row justify-content-end">
            <div class="dropup mg-b-15 mg-sm-b-0 mg-sm-r-auto">
              <button type="button" class="btn btn-block bd bd-gray-300 d-flex align-items-center"
                      data-bs-toggle="dropdown">Add More Fields
                <ion-icon name="chevron-up-outline" class="mg-l-5"></ion-icon>
              </button>
              <div class="dropdown-menu tx-13">
                <a href="" class="dropdown-item">Email</a>
                <a href="" class="dropdown-item">Phone</a>
                <a href="" class="dropdown-item">Address</a>
                <a href="" class="dropdown-item">Custom</a>
              </div><!-- dropdown-menu -->
            </div>

            <button v-on:click="validateContactAndSubmit" type="button" class="btn btn-primary mg-b-5 mg-sm-b-0">Save
              Changes
            </button>
            <button type="button" ref="closeModalBtn" class="btn btn-secondary mg-sm-l-5" data-bs-dismiss="modal">Cancel
            </button>
          </div>
        </div><!-- modal-footer -->
      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->


</template>


<script>
import visualizationMixin from "@/mixins/visualization-script";
import footerScriptMixin from "@/mixins/footer-script";
import serviceMixin from "@/mixins/contact-service";
//import SideBarAsideFix from "../components/SideBarAsideFix.vue";
import {computed, reactive} from "vue";
import {email, numeric, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import SideBarAsideMail from "../components/SideBarAsideMail.vue";


export default {
  name: "UserDetails",
  components: {SideBarAsideMail},
  mixins: [footerScriptMixin, serviceMixin, visualizationMixin],
  watch: {
    $store: {
      handler() {
        this.getContactForEdit();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      formError: null,
      param: null,
      emailId: this.state.email
    }
  },
  created() {
    this.asideBarScript();
    this.param = this.$route.params.id;
    this.getContactForEdit(this.param);
    this.mailFooterScript();
  },

  setup() {
    const state = reactive({
      first_name: "",
      middle_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      contact_address: "",
      marital_status: "",
      town_city: "",
      county: "",
      post_code: "",
      birthday_month: "",
      birthday_day: "",
      gender: "",
      first_attendance: "",
      bfc_status: "",
      water_baptism: "",
      service_unit: "",
      wofbi_status: "",
      profile_picture: "",
      id: "",
    })
    const rules = computed(() => {
      return {
        first_name: {required},
        last_name: {required},
        email: {required, email},
        phone_number: {required, numeric},
        contact_address: {required},
        town_city: {required},
        county: {required},
        post_code: {required},
        gender: {required},
        first_attendance: {required},
        bfc_status: {required},
        water_baptism: {required},
        wofbi_status: {required},
      }
    });
    const v$ = useVuelidate(rules, state)
    return {state, v$}
  },

  methods: {
    async validateContactAndSubmit() {
      this.report = "";
      this.v$.$validate();
      if (this.v$.$error) {
        this.formError = "Please Fix the error in the form"
      } else {
        this.formError = null;
        this.$refs.closeModalBtn.click();
        this.report = await this.saveContact(this.state).catch(err => {
          return {
            details: err.response.data.errorMessage,
            failed: true
          };
        });

        let url = await this.buildQueryParam(this.page);
        await this.getContacts(url);
      }
    },

    async onPhotoSelected(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (confirm("Do you really want to upload this photo?")) {
        let formData = new FormData();
        formData.append('file', file);
        try {
          await this.patchContactPhoto(this.state.id, formData);
          alert("Photo uploaded successfully");
          await this.getContactForEdit(this.state.id);
        } catch (error) {
          console.error(error);
          if (error.response && error.response.data && error.response.data.errorMessage) {
            alert(error.response.data.errorMessage);
          } else {
            alert("Failed to upload photo");
          }
        }
      }
      // Reset input
      event.target.value = '';
    },

    async getContactForEdit(id) {


      let contact = await this.findContactsById(id)
          .catch(err => {
            console.log(err);
            //window.location.replace('/deposits');
          })


      // let contact = this.$store.state.selected_contact;  Replace with this Store Later
      this.state.first_name = contact.first_name;
      this.state.middle_name = contact.middle_name;
      this.state.last_name = contact.last_name;
      this.state.email = contact.email;
      this.state.phone_number = contact.phone_number;
      this.state.marital_status = contact.marital_status;
      this.state.town_city = contact.town_city;
      this.state.contact_address = contact.contact_address;
      this.state.county = contact.county;
      this.state.post_code = contact.post_code;
      this.state.birthday_month = contact.birthday_month;
      this.state.birthday_day = contact.birthday_day;
      this.state.gender = contact.gender;
      this.state.first_attendance = contact.first_attendance;
      this.state.bfc_status = contact.bfc_status;
      this.state.water_baptism = contact.water_baptism;
      this.state.service_unit = contact.service_unit;
      this.state.wofbi_status = contact.wofbi_status;
      this.state.profile_picture = contact.profile_picture;
      this.state.id = contact?.id;

    }

  }
}
</script>

<style scoped>
@import '../../assets/css/dashforge.profile.css';

.d-block {
  margin-bottom: 3px;
}

.app-mail.mail-sidebar-show .mail-wrapper {
  transform: translateX(0);
}

@media (max-width: 991.98px) {
  .app-mail.mail-content-show .mail-wrapper {
    transform: translateX(-200vw);
  }
}

.mail-wrapper {
  position: fixed;
  top: 55px;
  bottom: 0;
  left: 0;
  right: 0;
  transform: translateX(-100vw);
  transition: all 0.3s;
}

@media (prefers-reduced-motion: reduce) {
  .mail-wrapper {
    transition: none;
  }
}

@media (min-width: 375px) {
  .mail-wrapper {
    transform: translateX(-220px);
  }
}

@media (min-width: 768px) {
  .mail-wrapper {
    transform: translateX(0);
  }
}

@media (min-width: 992px) {
  .mail-wrapper {
    top: 60px;
  }
}

@media (min-width: 992px) {
  .mail-wrapper-two {
    position: relative;
    height: 100%;
    top: auto;
  }
}

.mail-sidebar {
  background-color: #fff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100vw;
}

@media (min-width: 375px) {
  .mail-sidebar {
    width: 220px;
    border-right: 1px solid rgba(72, 94, 144, 0.16);
  }
}

@media (min-width: 768px) {
  .mail-sidebar {
    left: 0;
    opacity: 1;
    visibility: visible;
  }
}

.mail-sidebar-body {
  position: relative;
  height: 100%;
}

.mail-group {
  width: 100vw;
  position: absolute;
  top: 0;
  left: 100vw;
  bottom: 0;
  transition: all 0.3s;
}

@media (prefers-reduced-motion: reduce) {
  .mail-group {
    transition: none;
  }
}

@media (min-width: 375px) {
  .mail-group {
    left: 220px;
  }
}

@media (min-width: 768px) {
  .mail-group {
    width: auto;
    right: 0;
    left: 220px;
  }
}

@media (min-width: 1200px) {
  .mail-group {
    width: 320px;
    border-right: 1px solid rgba(72, 94, 144, 0.16);
  }
}

.mail-group-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 55px;
  background-color: #fff;
  border-bottom: 1px solid rgba(72, 94, 144, 0.16);
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.mail-group-header .feather-search {
  color: #8392a5;
  align-self: center;
  width: 18px;
  stroke-width: 2.8px;
  margin-right: 10px;
  margin-top: -2px;
}

.mail-group-header .search-form {
  flex: 1;
  display: flex;
  align-items: center;
}

.mail-group-header .search-form .form-control {
  border-width: 0;
  background-color: transparent;
  font-size: inherit;
  padding: 0;
  color: #1b2e4b;
}

.mail-group-body {
  position: absolute;
  top: 55px;
  left: 0;
  right: 0;
  bottom: 0;
}

.mail-group-body .media {
  padding: 15px 20px;
  background-color: #f8f9fc;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .mail-group-body .media {
    transition: none;
  }
}

.mail-group-body .media:hover, .mail-group-body .media:focus {
  background-color: #f3f8ff;
}

.mail-group-body .media.unread, .mail-group-body .media.unread:hover, .mail-group-body .media.unread:focus {
  background-color: #fff;
}

.mail-group-body .media.selected, .mail-group-body .media.selected:hover, .mail-group-body .media.selected:focus {
  background-color: #ecf4ff;
}

.mail-group-body .media + .media {
  margin-top: -1px;
  border-top: 1px solid #e5e9f2;
}

.mail-group-label {
  display: block;
  padding: 6px 20px;
  background-color: rgba(229, 233, 242, 0.8);
  text-transform: uppercase;
  font-size: 10px;
  font-family: -apple-system, BlinkMacSystemFont, "Inter UI", Roboto, sans-serif;
  font-weight: 500;
  letter-spacing: .5px;
  color: #8392a5;
  margin: 1px 0;
}

.mail-group-label:first-of-type {
  margin-top: 0;
}

.mail-content {
  position: absolute;
  top: 0;
  left: 200vw;
  bottom: 0;
  width: 100vw;
  background-color: #f5f6fa;
}

@media (min-width: 1200px) {
  .mail-content {
    left: 540px;
    width: auto;
    right: 0;
  }
}

.mail-content-header {
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 55px;
  border-bottom: 1px solid rgba(72, 94, 144, 0.16);
  padding: 0 20px;
  display: flex;
  align-items: center;
}

.mail-content-body {
  background-color: #fff;
  position: absolute;
  top: 55px;
  left: 0;
  right: 0;
  bottom: 0;
}

.mail-compose {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(15, 21, 32, 0.7);
  z-index: 1050;
  opacity: 0;
  visibility: hidden;
  transform: scale(1.2, 1.2);
  transition: all 0.3s;
}

@media (prefers-reduced-motion: reduce) {
  .mail-compose {
    transition: none;
  }
}

.mail-compose.show {
  opacity: 1;
  visibility: visible;
  transform: scale(1, 1);
}

.mail-compose.show.shrink {
  background-color: transparent;
  pointer-events: none;
}

.mail-compose.show.shrink .mail-compose-dialog {
  width: 500px;
  right: 10px;
  bottom: 0;
  transform: translate(0, 0);
  pointer-events: all;
}

.mail-compose.show.shrink .nav-link-shrink svg:first-child {
  display: none;
}

.mail-compose.show.shrink .nav-link-shrink svg:last-child {
  display: block;
}

.mail-compose.show.shrink .mail-compose-body {
  padding: 20px;
  border-left: 1px solid rgba(72, 94, 144, 0.16);
  border-right: 1px solid rgba(72, 94, 144, 0.16);
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.mail-compose.show.minimize {
  background-color: transparent;
  pointer-events: none;
}

.mail-compose.show.minimize .mail-compose-dialog {
  width: 500px;
  top: auto;
  left: auto;
  right: 10px;
  bottom: 0;
  transform: none;
  pointer-events: all;
}

.mail-compose.show.minimize .nav-link-minimize svg:first-child {
  display: none;
}

.mail-compose.show.minimize .nav-link-minimize svg:last-child {
  display: block;
}

.mail-compose.show.minimize .mail-compose-body {
  display: none;
}

.mail-compose-dialog {
  position: absolute;
  bottom: 50%;
  right: 50%;
  transform: translate(50%, 50%);
  width: 80%;
  max-width: 840px;
  transition: all 0.3s;
}

@media (prefers-reduced-motion: reduce) {
  .mail-compose-dialog {
    transition: none;
  }
}

.mail-compose-header {
  background-color: #1c273c;
  padding: 20px;
  color: #fff;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mail-compose-header .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

.mail-compose-header .nav-link:hover, .mail-compose-header .nav-link:focus {
  color: #fff;
}

.mail-compose-header .nav-link svg:last-child:not(:first-child) {
  display: none;
}

.mail-compose-title {
  margin-bottom: 0;
  font-weight: 400;
  position: relative;
  top: 1px;
}

.mail-compose-body {
  background-color: #fff;
  padding: 20px;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  transition: all 0.3s;
}

@media (prefers-reduced-motion: reduce) {
  .mail-compose-body {
    transition: none;
  }
}

@media (min-width: 992px) {
  .mail-compose-body {
    padding: 30px;
  }
}

.mail-compose-body .form-control {
  box-shadow: none !important;
}

@media (min-width: 992px) {
  .aside-mail + .content {
    margin-left: 60px;
  }
}

.card-3b {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}


.form-group-mat {
  position: relative;
  margin: 10px 0;
}

/* The text field itself */
.form-group-mat input, .form-group-mat select {
  width: 100%;
  border: none;
  border-bottom: 1px solid #042893;
  padding: 10px 0 5px 0;
  background: transparent;
  outline: none;
  transition: border-color 0.3s;
}

.form-group-mat select {
  appearance: none; /* Remove default arrow */
  cursor: pointer;
}

/* Label floating above */
.form-group-mat label {
  position: absolute;
  top: 10px;
  left: 0;
  color: #042893;
  pointer-events: none;
  transition: 0.3s ease all;
}

/* Focus effect */
.form-group-mat input:focus, .form-group-mat select:focus {
  border-bottom: 2px solid #6200ee;
}


/* Original floating label rule */
.form-group-mat input:focus + label,
.form-group-mat.has-value label,
.form-group-mat.select-has-value label {
  top: -15px;
  color: #042893;
}

.form-group.select-has-value label {
  top: -15px;
  color: #042893;
}

/* Optional underline animation */
.form-group-mat input:focus::placeholder {
  color: transparent;
}

</style>









<!--<div class="content ht-100v pd-0">-->

<!--<div class="content-header">-->
<!--  <div class="content-search">-->
<!--    <i data-feather="search"></i>-->
<!--    <input type="search" class="form-control" placeholder="Search...">-->
<!--  </div>-->
<!--  <nav class="nav">-->
<!--    <a href="" class="nav-link"><i data-feather="help-circle"></i></a>-->
<!--    <a href="" class="nav-link"><i data-feather="grid"></i></a>-->
<!--    <a href="" class="nav-link"><i data-feather="align-left"></i></a>-->
<!--  </nav>-->
<!--</div>&lt;!&ndash; content-header &ndash;&gt;-->

<!--<div class="content-body">-->
<!--  <div class="container pd-x-0 pd-lg-x-10 pd-xl-x-0">-->
<!--    <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">-->
<!--      <div>-->
<!--        <nav aria-label="breadcrumb">-->
<!--          <ol class="breadcrumb breadcrumb-style1 mg-b-10">-->
<!--            <li class="breadcrumb-item"><a href="#">Dashboard</a></li>-->
<!--            <li class="breadcrumb-item active" aria-current="page">Harvest DataCenter</li>-->
<!--          </ol>-->
<!--        </nav>-->
<!--        <h4 class="mg-b-0 tx-spacing&#45;&#45;1">Welcome to Dashboard</h4>-->
<!--      </div>-->
<!--      <div class="d-none d-md-block">-->
<!--        <button class="btn btn-sm pd-x-15 btn-white btn-uppercase"><i data-feather="mail" class="wd-10 mg-r-5"></i>-->
<!--          Email-->
<!--        </button>-->
<!--        <button class="btn btn-sm pd-x-15 btn-white btn-uppercase mg-l-5"><i data-feather="printer"-->
<!--                                                                             class="wd-10 mg-r-5"></i> Print-->
<!--        </button>-->
<!--        <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i data-feather="file"-->
<!--                                                                               class="wd-10 mg-r-5"></i> SMS-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="row row-xs">-->
<!--      <div class="card col-lg-3 card-3b" >-->
<!--        <div class="card-body pd-10 pd-sm-20">-->
<!--          <div class="clearfix mg-b-25">-->
<!--            <div id="contactAvatar" class="pos-relative float-start">-->
<!--              <div class="avatar avatar-xl"><span class="avatar-initial rounded-circle bg-gray-700 tx-normal">A</span></div>-->
<!--              <a href="" class="contact-edit-photo" data-bs-toggle="tooltip" title="Upload Photo"><i data-feather="edit-2"></i></a>-->
<!--            </div>-->
<!--          </div>-->
<!--          <h5 id="contactName" class="tx-18 tx-xl-20 mg-b-5">Abigail Johnson</h5>-->
<!--          <p class="tx-13 tx-lg-12 tx-xl-13 tx-color-03 mg-b-20">President &amp; CEO - ThemePixels, Inc.</p>-->
<!--          <nav class="contact-call-nav mg-b-20">-->
<!--            <a href="#" class="nav-call" data-bs-toggle="tooltip" title="Make a Phone Call"><i data-feather="phone"></i></a>-->
<!--            <a href="#" class="nav-video" data-bs-toggle="tooltip" title="Make a Video Call"><i data-feather="video"></i></a>-->
<!--            <a href="#" class="nav-msg" data-bs-toggle="tooltip" title="Send Message"><i data-feather="message-square"></i></a>-->
<!--          </nav>&lt;!&ndash; contact-call-nav &ndash;&gt;-->

<!--          <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Biography</label>-->
<!--          <p class="tx-13 mg-b-0">Gambler, Tea Drinker, Ultimate Piggie, Replacement President of a Major Soft Drink Manufacturer. When I give out candies, I give people the flavour I don't like. </p>-->

<!--          <hr class="mg-y-20">-->

<!--          <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-15">Options</label>-->
<!--          <nav class="nav flex-column contact-content-nav mg-b-25">-->
<!--            <a href="" class="nav-link"><i data-feather="share"></i> Share this Contact</a>-->
<!--            <a href="" class="nav-link"><i data-feather="star"></i> Add to Favorites</a>-->
<!--            <a href="" class="nav-link"><i data-feather="slash"></i> Block this Contact</a>-->
<!--          </nav>-->
<!--        </div>-->
<!--      </div>&lt;!&ndash; contact-content-sidebar &ndash;&gt;-->

<!--      <div class="col-lg-9 ">-->
<!--        <div class="card card-crypto card-3b">-->
<!--          <div class="contact-content-header">-->
<!--            <nav class="nav">-->
<!--              <a href="#contactInformation" class="nav-link active" data-bs-toggle="tab">Contact Information</a>-->
<!--              <a href="#contactLogs" class="nav-link" data-bs-toggle="tab"><span>Call &amp; Message </span>Lxaogs</a>-->
<!--            </nav>-->
<!--            <a href="" id="contactOptions" class="text-secondary mg-l-auto d-xl-none"><i data-feather="more-horizontal"></i></a>-->
<!--          </div>&lt;!&ndash; contact-content-header &ndash;&gt;-->

<!--          <div class="pd-10 pd-sm-20 mg-t-30">-->
<!--            <div class="tab-content">-->
<!--              <div id="contactInformation" class="tab-pane show active pd-20 pd-xl-25">-->

<!--                <div class="d-flex align-items-center justify-content-between mg-b-25">-->
<!--                  <h6 class="mg-b-0">Personal Details</h6>-->
<!--                  <div class="d-flex">-->
<!--                    <a href="#modalEditContact" data-bs-toggle="modal" class="btn btn-sm btn-white d-flex align-items-center mg-r-5"><i data-feather="edit-2"></i><span class="d-none d-sm-inline mg-l-5"> Edit</span></a>-->
<!--                    <a href="#modalDeleteContact" data-bs-toggle="modal" class="btn btn-sm btn-white d-flex align-items-center"><i data-feather="trash"></i><span class="d-none d-sm-inline mg-l-5"> Delete</span></a>-->
<!--                  </div>-->
<!--                </div>-->

<!--                <div class="row">-->
<!--                  <div class="col-6 col-sm">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Firstname</label>-->
<!--                    <p class="mg-b-0">Abigail</p>-->
<!--                  </div>&lt;!&ndash; col &ndash;&gt;-->
<!--                  <div class="col-6 col-sm">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Middlename</label>-->
<!--                    <p class="mg-b-0">Christensen</p>-->
<!--                  </div>&lt;!&ndash; col &ndash;&gt;-->
<!--                  <div class="col-sm mg-t-20 mg-sm-t-0">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Lastname</label>-->
<!--                    <p class="mg-b-0">Johnson</p>-->
<!--                  </div>&lt;!&ndash; col &ndash;&gt;-->
<!--                </div>&lt;!&ndash; row &ndash;&gt;-->

<!--                <h6 class="mg-t-40 mg-b-20">Contact Details</h6>-->

<!--                <div class="row row-sm">-->
<!--                  <div class="col-6 col-sm-4">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Mobile Phone</label>-->
<!--                    <p class="tx-primary tx-rubik mg-b-0">+1 290 912 3868</p>-->
<!--                  </div>-->
<!--                  <div class="col-6 col-sm-4">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Home Phone</label>-->
<!--                    <p class="tx-primary tx-rubik mg-b-0">+1 011 342 3129</p>-->
<!--                  </div>-->
<!--                  <div class="col-6 col-sm-4 mg-t-20 mg-sm-t-0">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Work Phone</label>-->
<!--                    <p class="tx-primary tx-rubik mg-b-0">+1 100 003 3344</p>-->
<!--                  </div>-->
<!--                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Email Address</label>-->
<!--                    <p class="tx-primary mg-b-0">me@themepixels.me</p>-->
<!--                  </div>-->
<!--                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Company</label>-->
<!--                    <p class="mg-b-0">ThemePixels, Inc.</p>-->
<!--                  </div>-->
<!--                  <div class="col-sm-4 mg-t-20 mg-sm-t-30">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Job Position</label>-->
<!--                    <p class="mg-b-0">President &amp; CEO</p>-->
<!--                  </div>-->
<!--                  <div class="col-sm-6 mg-t-20 mg-sm-t-30">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Home Address</label>-->
<!--                    <p class="mg-b-0">4658 Kenwood Place<br>Pompano Beach, FL 33060, United States</p>-->
<!--                  </div>-->
<!--                  <div class="col-sm-6 mg-t-20 mg-sm-t-30">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Work Address</label>-->
<!--                    <p class="mg-b-0">819 Waldeck Street<br>Farmers Branch, TX 75244, United States</p>-->
<!--                  </div>-->
<!--                  <div class="col-sm-6 mg-t-20 mg-sm-t-30">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Personal Website</label>-->
<!--                    <p class="tx-primary mg-b-0">http://themepixels.me/</p>-->
<!--                  </div>-->
<!--                  <div class="col-sm-6 mg-t-20 mg-sm-t-30">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Social Profiles</label>-->
<!--                    <nav class="nav nav-social">-->
<!--                      <a href="" class="nav-link"><i data-feather="facebook"></i></a>-->
<!--                      <a href="" class="nav-link"><i data-feather="twitter"></i></a>-->
<!--                      <a href="" class="nav-link"><i data-feather="instagram"></i></a>-->
<!--                      <a href="" class="nav-link"><i data-feather="github"></i></a>-->
<!--                    </nav>-->
<!--                  </div>&lt;!&ndash; col &ndash;&gt;-->
<!--                  <div class="col-sm mg-t-20 mg-sm-t-30">-->
<!--                    <label class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-b-10">Notes</label>-->
<!--                    <p class="tx-13 mg-b-0">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>-->
<!--                  </div>-->
<!--                </div>&lt;!&ndash; row &ndash;&gt;-->
<!--              </div>-->
<!--              <div id="contactLogs" class="tab-pane pd-20 pd-xl-25">-->
<!--                <div class="d-flex align-items-center justify-content-between mg-b-30">-->
<!--                  <h6 class="tx-15 mg-b-0">Call &amp; Message Logs</h6>-->
<!--                  <a href="#" class="btn btn-sm btn-white d-flex align-items-center"><ion-icon name="time-outline" class="mg-r-5 tx-16 lh&#45;&#45;9"></ion-icon> Clear History</a>-->
<!--                </div>-->
<!--              </div>&lt;!&ndash; tab-pane &ndash;&gt;-->
<!--            </div>&lt;!&ndash; tab-content &ndash;&gt;-->

<!--          </div>&lt;!&ndash; card-body &ndash;&gt;-->
<!--        </div>&lt;!&ndash; card &ndash;&gt;-->
<!--      </div>&lt;!&ndash; col &ndash;&gt;-->


<!--    </div>&lt;!&ndash; row &ndash;&gt;-->
<!--  </div>&lt;!&ndash; container &ndash;&gt;-->
<!--</div>-->
<!--</div>&lt;!&ndash; content &ndash;&gt;-->
